import i18next from "i18next";
import React from "react";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const OrderReference: React.FC<Props> = ({ value, onChange }) => (
  <div className="form form__reference">
    <label className="label " htmlFor="reference">
      {i18next.t("ORDER REFERENCE")}
    </label>
    <input
      type="text"
      className="input--text"
      id="reference"
      name="reference"
      maxLength={20}
      placeholder={i18next.t("ORDER REFERENCE")}
      aria-label={i18next.t("ORDER REFERENCE")}
      aria-required="false"
      value={value}
      onChange={onChange}
    />
  </div>
);

export default OrderReference;
